import React from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";
import AuthForm from './AuthForm';

function Navbar() {
    return (
        <nav className="navbar">
            <h2 className="logo">Tooth <span className="logo-accent">Talk</span></h2>
            <div className="nav-links">
                <Link to="/">Home</Link>
                <Link to="/transcribe">Transcribe</Link>
                <Link to="/appointments">Appointments</Link>
            </div>
            <div className="nav-right">
                {/* <AuthForm showDebugActions={true} /> */}
                <AuthForm showDebugActions={false} />
            </div>
        </nav>
    );
}

export default Navbar;
